<template>
  <div>
    <div class="p-userForm">
      <div class="p-box">
        <div class="p-box__body">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form v-show="!loading" @submit.prevent="handleSubmit($event, onSubmit)">
              <div class="c-grid">
                <div class="c-grid__items">
                  <div class="c-grid__item c-grid__item__s__12 c-grid__item__m__12 c-grid__item__l__6">
                    <div class="p-userForm__name">
                      <div class="c-grid__item__s__6 c-grid__item__m__6 c-grid__item__l__6">
                        <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="last_name" :name="$t('models.user.lastName')" rules="required">
                          <p class="c-formLabel">
                            {{ $t('models.user.lastName') }}
                            <span v-for="error in errors" :key="error" class="c-error-msg">
                              {{ error }}
                            </span>
                          </p>
                          <TextField :value="value" :placeholder="$t('labels.placeholder.basic')" autocomplete="off" autofocus="true" @input="handleChange" />
                        </ValidationProvider>
                      </div>
                      <div class="c-grid__item__s__6 c-grid__item__m__6 c-grid__item__l__6">
                        <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="first_name" :name="$t('models.user.firstName')" rules="required">
                          <p class="c-formLabel">
                            {{ $t('models.user.firstName') }}
                            <span v-for="error in errors" :key="error" class="c-error-msg">
                              {{ error }}
                            </span>
                          </p>
                          <TextField :value="value" :placeholder="$t('labels.placeholder.basic')" autocomplete="off" @input="handleChange" />
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="p-userForm__email">
                      <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="email" :name="$t('models.user.email')" rules="required|email">
                        <p class="c-formLabel">
                          {{ $t('models.user.email') }}
                          <span v-for="error in errors" :key="error" class="c-error-msg">
                            {{ error }}
                          </span>
                        </p>
                        <TextField :value="value" :placeholder="$t('labels.placeholder.basic')" autocomplete="off" @input="handleChange" />
                      </ValidationProvider>
                    </div>
                    <div class="p-userForm__password">
                      <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="password" :name="$t('models.user.newPassword')" rules="password">
                        <p class="c-formLabel">
                          {{ $t('models.user.newPassword') }}
                          <span v-for="error in errors" :key="error" class="c-error-msg">
                            {{ error }}
                          </span>
                        </p>
                        <TextField :value="value" autocomplete="off" type="password" @input="handleChange" />
                      </ValidationProvider>
                    </div>
                    <div class="p-userForm__password">
                      <ValidationProvider v-slot="{ errors, value, handleChange }" v-model="password_confirmation" :name="$t('models.user.confirmNewPassword')" rules="password">
                        <p class="c-formLabel">
                          {{ $t('models.user.newPasswordConfirmation') }}
                          <span v-for="error in errors" :key="error" class="c-error-msg">
                            {{ error }}
                          </span>
                        </p>
                        <TextField :value="value" autocomplete="off" type="password" @input="handleChange" />
                        <p v-show="pending_reconfirmation">{{ $t('pages.companies.accountSetting.pendingReconfirmation') }}: {{ email }}</p>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="c-info">
                <div class="c-info__icon"><Icon name="iconQuestion" /></div>
                <p>{{ $t('pages.companies.accountSetting.info') }}</p>
              </div>
              <div class="c-button c-button--right">
                <a class="c-button__item c-button__item--outline-cancel" href="/">{{ $t('labels.cancel') }}</a>
                <button class="c-button__item c-button__item--primary">
                  {{ $t('labels.save') }}
                </button>
              </div>
            </form>
          </ValidationObserver>
          <Loading v-show="loading" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import TextField from '../components/TextField'
import Loading from '../components/Loading'
import Icon from '../components/Icon'

export default {
  name: 'AccountSetting',
  components: {
    TextField,
    Loading,
    Icon,
  },
  data() {
    return {
      last_name: '',
      first_name: '',
      email: '',
      password: '',
      password_confirmation: '',
    }
  },
  computed: {
    ...mapState({
      account_setting: state => state.companiesAccountSetting.data,
      pending_reconfirmation: state => state.companiesAccountSetting.meta.pending_reconfirmation,
      loading: state => state.companiesAccountSetting.loading,
      writeError: state => state.companiesAccountSetting.writeError,
    }),
    currentCompanyUuid: function () {
      return this.$route.params.company_uuid
    },
  },
  async created() {
    await this.readAccountSetting(this.currentCompanyUuid)
    this.last_name = this.account_setting.last_name
    this.first_name = this.account_setting.first_name
    this.email = this.account_setting.email
  },
  methods: {
    ...mapActions({
      readAccountSetting: 'companiesAccountSetting/readAccountSetting',
      writeAccountSetting: 'companiesAccountSetting/writeAccountSetting'
    }),
    async onSubmit() {
      const payload = {
        account_setting: {
          last_name: this.last_name,
          first_name: this.first_name,
          email: this.email,
          password: this.password,
          password_confirmation: this.password_confirmation,
        }
      }
      this.password = ''
      this.password_confirmation = ''
      await this.writeAccountSetting({ companyUuid :this.currentCompanyUuid, payload: payload})
      if (!this.writeError && payload.account_setting.password) {
        this.$router.push('/s')
        location.href = '/users/sign_in'
      }
    }
  },
}
</script>
<style lang="scss" scoped>
</style>
